module.exports = __webpack_public_path__ + "media/images/glyphs/arrow-21fd3eba533192d3ed02c82ebe283242.svg";